import { z } from 'zod';
import { TabelaPrecoTipoVariacao } from '@/features/tabela-preco/types/enum';
import { TabelaPrecoProdutoExcecaoSchema } from '@/features/tabela-preco/types/TabelaPrecoProduto';

const ProdutoTabelaPrecoProdutoSchema = z.object({
    pro_codigo_interno: z.number(),
    pro_descricao: z.string(),
    pro_preco_minimo: z.number().nullable(),
    pro_preco_venda: z.number().nullable(),
    pro_sku: z.string().nullable(),
});

export const ProdutoTabelaPrecoSchema = z.object({
    preco_calculado: z.number(),
    preco_tabela: z.number(),
    produto: ProdutoTabelaPrecoProdutoSchema,
    tabela_preco_excecao: TabelaPrecoProdutoExcecaoSchema.nullable(),
    tap_descricao: z.string(),
    tap_empresa_idpk: z.number(),
    tap_idpk: z.number(),
    tap_percentual: z.number().nullable(),
    tap_tipo_variacao: z.enum(TabelaPrecoTipoVariacao),
});
